// extracted by mini-css-extract-plugin
module.exports = {"badge":"_3beoCDoa7Ggt","tooltip":"_31muYw9SaE-x","inner":"_1H9wvz0fxlfK","shadow":"_3Zd4a2lvPQZ4","wrapper":"_38lzDTipPM6I"};